.<template>
    <div class="components-container">
        <el-row class="stickyContent" style="top:0px;">
            <div class="titles">
                <span class="fonts">教学进程表（学年制）</span>
                <el-button @click="addCAP()" type="success" size="mini" :disabled="editDisableState">
                    <i class="el-icon-plus"></i>
                </el-button>
                <el-button @click="popGrid()" type="danger" size="mini" :disabled="editDisableState">
                    <i class="el-icon-minus"></i>
                </el-button>
            </div>
        </el-row>

        <el-row style="display:none;">
            <span>
                <p>课程名称下拉框的数据来自系统内已设置的课程。</p>
                <p>
                    课程分为公共课程和专业课程。<br />
                    公共课程的课程代码由6位固定代码100000+4位序号构成<br />专业课程的课程代码由6位国标专业编号+1位模式代码+2位序号+1位学期号构成
                </p>
                <p>
                    总学时验证规则：总学时-各学期周学时*周数之和。若等于则通过，否则给予相应提示。
                </p>
            </span>
        </el-row>

        <el-row class="courseContent">
            <el-table
                :data="CAPS"
                ref="CAPTable"
                :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                element-loading-text="信息加载中"
                stripe
                border
                class="tb-edit"
                fit
                highlight-current-row
                show-summary
                :summary-method="getSummaries"
                style="width: 100%;"
                :height="capTableHeight"
                @selection-change="handleCoursesSelection"
                :row-style="{ 'height':'64px' }"
                @row-click="(row, column, event) => handleRowClick('CAPTable', row, column, event)"
            >
                <el-table-column type="selection" width="55"> </el-table-column>

                <el-table-column label="序号" width="65" align="center" prop="xh" fixed>
                    <template slot-scope="scope">
                        <span class="el-edit">
                        <el-input v-model="scope.row.xh"
                            :controls="false"
                            style="width: 45px"
                            size="mini"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            @change="handleChangeXH(scope)"
                        ></el-input>
                        </span>
                        <span>{{ formatterNumShow(scope.row.xh) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程类别" prop="courseKind" width="160" align="center" fixed>
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.courseKind"
                                placeholder="请选择"
                                @visible-change="handleCourseTypeOptionVisible(scope)"
                                @change="handleCourseTypeChange(scope)">
                                <el-option v-for="(item, index) in kinds"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.courseTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程性质" prop="courseProperties" width="160" align="center" fixed >
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.courseProperties"
                                :placeholder="scope.row.kcsxholder" :disabled="scope.row.kcsxDisabled"
                                @visible-change="handleCoursePropertiesOptionVisible(scope)">
                                <el-option v-for="(item, index) in kcsxInfo"
                                    :key="index"
                                    :label="item.comboName"
                                    :value="item.comboValue"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.coursePropertiesName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程名称" min-width="220" fixed>
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.fullName"
                                @focus="handleCourseFocus(scope)"
                                @visible-change="handleCourseOptionVisible(scope)"
                                @change="handleCourseChange(scope)"
                                :filter-method="searchFilterCourse" filterable>
                                <el-option v-for="(item, index) in filterOptionCourses"
                                    :key="item.label+index"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="item.disabled"
                                ></el-option>
                                <el-option v-if="filterOptionCourses.length === 10 && tempOptionCourses.length > 10 ||
                                    filterOptionCourses.length === 11 && tempOptionCourses.length > 11" value="tip" disabled>
                                    <span class="gray">--只展示前10条数据，更多数据请输入详细查询条件--</span>
                                </el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.courseName }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="课程性质" width="110" align="center" prop="coursePropertiesName">
                    <template slot-scope="scope">
                        <span class="el-edit">{{ scope.row.coursePropertiesName }}</span>
                        <span>{{ scope.row.coursePropertiesName }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="课程类型" width="80" align="center" prop="courseCategoryName">
                    <template slot-scope="scope">
                        <span class="el-edit">{{ scope.row.courseCategoryName }}</span>
                        <span>{{ scope.row.courseCategoryName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="学分" width="90" align="center" prop="score">
                    <template slot-scope="scope">
                        <!-- <span class="el-edit">
                            <el-input-number v-model="scope.row.score"
                                style="width: 70px"
                                :controls="false"
                                size="mini"
                                :min="0"
                            ></el-input-number>
                        </span> -->
                        <span>{{ formatterNumShow(scope.row.score) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总学时" width="90" align="center" prop="totalTime">
                    <template slot-scope="scope">
                        <!-- <span class="el-edit">
                        <el-input-number v-model="scope.row.totalTime"
                            :controls="false"
                            style="width: 70px"
                            size="mini"
                            :min="0"
                        ></el-input-number>
                        </span> -->
                        <span>{{ formatterNumShow(scope.row.totalTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="理论教学" width="90" prop="theoryTime" align="center">
                    <template slot-scope="scope">
                        <!-- <span class="el-edit">
                            <el-input-number v-model.number="scope.row.theoryTime"
                                v-if="renderFlag"
                                class="numbers"
                                controls-position="right"
                                :max="1000"
                                size="mini"
                                style="width: 70px"
                                :step="1"
                                :step-strictly="true"
                                :min="0"
                                :controls="false"
                                @change="handleChange(scope)"
                            ></el-input-number>
                        </span> -->
                        <span>{{ formatterNumShow(scope.row.theoryTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实验实训" width="90" prop="practiseTime" align="center">
                    <template slot-scope="scope">
                        <!-- <span class="el-edit">
                            <el-input-number v-model.number="scope.row.practiseTime"
                                v-if="renderFlag"
                                class="numbers"
                                controls-position="right"
                                :max="1000"
                                size="mini"
                                style="width: 70px"
                                :step="1"
                                :min="0"
                                :step-strictly="true"
                                :controls="false"
                                @change="handleChange(scope)"
                            ></el-input-number>
                        </span> -->
                        <span>{{ formatterNumShow(scope.row.practiseTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="'是否专业\n核心课程'" width="90" prop="isMajorcore" align="center">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.isMajorcore" placeholder="请选择" @change="handleMajorcoreChange(scope)">
                                <el-option v-for="(item, index) in sfzt"
                                    :key="index"
                                    :label="item.comboName"
                                    :value="item.comboValue"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.isMajorcoreName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="'是否考证\n课程'" width="90" prop="isCertificate" align="center">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.isCertificate" placeholder="请选择" @change="handleCertificateChange(scope)">
                                <el-option v-for="(item, index) in sfzt"
                                    :key="index"
                                    :label="item.comboName"
                                    :value="item.comboValue"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.isCertificateName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="考核方式" width="110" prop="examType" align="center">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.examType" placeholder="请选择" @change="handleExamTypeChange(scope)">
                                <el-option v-for="(item, index) in examType"
                                    :key="index"
                                    :label="item.comboName"
                                    :value="item.comboValue"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.examTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="各学期周数、学时分配" align="center">
                    <el-table-column label="一" v-if="xz*2>=1">
                        <el-table-column :label="weeks.first" prop="term1" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term1" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week1" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                    <!-- <el-input-number v-model.number="scope.row.week1"
                                        v-if="renderFlag"
                                        class="numbers"
                                        controls-position="right"
                                        :max="1000"
                                        style="width:50px; margin-left:-5px;"
                                        size="mini"
                                        :step="1"
                                        :step-strictly="true"
                                        :min="0"
                                        :controls="false"
                                        @change="handleChange(scope)"
                                    ></el-input-number>
                                    <el-input-number v-model.number="scope.row.term1"
                                        v-if="renderFlag"
                                        class="numbers"
                                        controls-position="right"
                                        :max="1000"
                                        style="width:50px; margin-left:-5px; margin-top:5px;"
                                        size="mini"
                                        :step="1"
                                        :step-strictly="true"
                                        :min="0"
                                        :controls="false"
                                        @change="handleChange(scope)"
                                    ></el-input-number> -->
                                </span>
                                <span>{{ formatterNumHour(scope.row.term1,scope.row.week1) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="二" v-if="xz*2>=2">
                        <el-table-column :label="weeks.second" prop="term2" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term2" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week2" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term2,scope.row.week2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="三" v-if="xz*2>=3">
                        <el-table-column :label="weeks.third" prop="term3" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term3" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week3" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term3,scope.row.week3) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="四" v-if="xz*2>=4">
                        <el-table-column :label="weeks.fourth" prop="term4" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term4" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week4" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term4,scope.row.week4) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="五" v-if="xz*2>=5">
                        <el-table-column :label="weeks.fifth" prop="term5" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term5" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week5" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term5,scope.row.week5) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="六" v-if="xz*2>=6">
                        <el-table-column :label="weeks.sixth" prop="term6" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term6" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week6" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term6,scope.row.week6) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="七" v-if="xz*2>=7">
                        <el-table-column :label="weeks.seventh" prop="term7" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term7" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week7" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term7,scope.row.week7) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="八" v-if="xz*2>=8">
                        <el-table-column :label="weeks.eighth" prop="term8" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term8" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week8" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term8,scope.row.week8) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="九" v-if="xz*2>=9">
                        <el-table-column :label="weeks.ninth" prop="term9" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term9" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week9" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term9,scope.row.week9) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="十" v-if="xz*2>=10">
                        <el-table-column :label="weeks.tenth" prop="term10" align="center" width="110">
                            <template slot-scope="scope">
                                <span class="el-edit">
                                    <el-input v-model="scope.row.term10" v-if="renderFlag" style="width:90px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.week10" v-if="renderFlag" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')" @change="handleChange(scope)">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span>{{ formatterNumHour(scope.row.term10,scope.row.week10) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="备注" width="120" prop="bz" align="left">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-input v-model="scope.row.bz" placeholder=""></el-input>
                        </span>
                        <span>{{ scope.row.bz }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联课程" align="center" width="100" fixed="right">
                    <!--
                    <template slot-scope="scope">
                        <el-button type="primary" size="medium" @click="operation(scope)">维护课程标准</el-button>
                    </template>
                     -->
                     <template slot-scope="scope">
                         <el-button type="primary" size="medium" @click="relatedCourseConfig(scope.row)">设置</el-button>
                     </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-dialog title="关联课程设置" :visible.sync="dialogVisible" v-if="dialogVisible" width="1000px" top="150px" append-to-body>
            <div style="height:550px;">
                <relatedCourseConfig ref="relatedCourseConfig" :teachingSchemeCode="teachingSchemeCode" :courseCode="courseCode" :listHeight="450"></relatedCourseConfig>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import relatedCourseConfig from './relatedCourseConfig';

export default {
    props: ['courseComboInfo', 'editDisableState', 'xz'],
    components: {
        relatedCourseConfig,
    },
    data() {
        return {
            teachingSchemeCode: null,
            kind: "01",
            CAPS: [],
            CAPSMult: [],
            kinds: [],
            kcsx: [],
            kcsxInfo: [],
            examType: [],
            sfzt: [],
            optionCourses: [],//课程数据
            tempOptionCourses: [],//临时课程数据
            filterOptionCourses: [],//显示前10条课程数据
            oldCourseName: "",
            oldCourseType: "",
            weeks: {
                first: "18周",
                second: "18周",
                third: "18周",
                fourth: "18周",
                fifth: "18周",
                sixth: "18周",
                seventh: "18周",
                eighth: "18周",
                ninth: "18周",
                tenth: "18周",
            },
            renderFlag: true,
            dialogVisible: false,
            courseCode: null,
            randomKey: null,
            capTableHeight: 300,
        };
    },
    mounted() {
         this.$nextTick().then(() => {
             //固定表头位置
             // $('.courseContent .el-table .el-table__header-wrapper').css('position', '-webkit-sticky');
             // $('.courseContent .el-table .el-table__header-wrapper').css('position', 'sticky');
             // $('.courseContent .el-table .el-table__header-wrapper').css('top', '45px');
             // $('.courseContent .el-table .el-table__header-wrapper').css('z-index', '99999');
             // $('.courseContent .el-table__header thead tr:first th').removeClass('is-hidden');
             this.capTableHeight = window.innerHeight - 230;
             // 监听窗口大小变化
             let self = this;
             window.onresize = function() {
                 self.capTableHeight = window.innerHeight - 230;
             };
         });
    },
    updated() {
        // myTable是表格的ref属性值
        if (this.$refs.CAPTable && this.$refs.CAPTable.doLayout) {
            this.$refs.CAPTable.doLayout();
        }
    },
    methods: {
        addCAP() {
            if(this.courseComboInfo.length == 0){
                this.$alert("请先选择主要信息", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            let origin = {
                id: this.getId(6),
                xh: '',
                courseId: null,
                courseName: null,
                fullName: null,
                courseKind: "",
                courseProperties: "",
                coursePropertiesName: "",
                kcsxholder: '请先选择课程',
                kcsxDisabled: true,
                courseCategory: "",
                isMajorcore: '0',
                isMajorcoreName: '否',
                isCertificate: '0',
                isCertificateName: '否',
                examType: '01',
                examTypeName: '考试',
                totalTime: 0,
                score: 0,
                theoryTime: 0,
                practiseTime: 0,
                term1: 0,
                term2: 0,
                term3: 0,
                term4: 0,
                term5: 0,
                term6: 0,
                term7: 0,
                term8: 0,
                term9: 0,
                term10: 0,
                week1: 0,
                week2: 0,
                week3: 0,
                week4: 0,
                week5: 0,
                week6: 0,
                week7: 0,
                week8: 0,
                week9: 0,
                week10: 0,
                bz: '',
            };
            let copy = { ...origin };
            this.CAPS.push(copy);
        },
        operation(scope) {
            let query = scope.row.courseId;
            if (query == null) {
                this.$notify({
                    title: "错误",
                    message: "请先选择课程信息",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
            this.$emit("openWindow", query);
        },
        relatedCourseConfig(rowData){
            this.courseCode = rowData.courseId;
            if(this.courseCode==null || this.courseCode==''){
                this.$alert("请先选择课程信息", "提示", {
                    confirmButtonText: "确定",
                });

                return;
            }

            this.dialogVisible = true;
        },
        loadComboOption(mode) {
            let param = {
                mode: mode,
            };
            this.$api.teachingManage.teachingScheme.loadComboOption({
                data: param,
            }).then((res) => {
                this.kinds = res.data.data.courseType;
                this.examType = res.data.data.examType;
                this.sfzt = res.data.data.sfzt;
                this.kcsx = res.data.data.courseProperties;
            }).catch((err) => {
                console.log(err);
            });
        },
        handleCoursesSelection(val) {
            this.CAPSMult = val;
        },
        popGrid() {
            if (this.CAPSMult.length === 0) return;

            this.restoreOptions();

            this.arrayMinus(this.CAPS, this.CAPSMult);

            this.$nextTick(() => {
                this.$refs.CAPTable.clearSelection();
            });
        },
        restoreOptions() {
            this.CAPSMult.forEach((item) => {
                this.setDisable(this.courseComboInfo[item.courseKind], item.fullName);
            });
        },
        setDisable(course, fullName) {
            if(course!=undefined){
                course.forEach((item) => {
                    if (item.value === fullName) item.disabled = false;
                });
            }
        },
        getId(length) {
            return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
        },
        arrayMinus(arr1, arr2) {
            //arr1 - arr2
            arr1.forEach((item) => {
                item.id = this.getId();
            });
            arr2.forEach((item) => {
                item.id = this.getId();
            });
            for (let i = arr1.length - 1; i >= 0; i--) {
                let x = arr1[i].id;
                for (let k = arr2.length - 1; k >= 0; k--) {
                    if (arr2[k].jkKclx === "0") continue;
                    let y = arr2[k].id;
                    if (x == y) {
                        arr1.splice(i, 1);
                        arr2.splice(k, 1);
                        break;
                    }
                }
            }
        },
        handleCourseTypeOptionVisible(scope) {
            this.oldCourseType = scope.row.courseKind;
        },
        handleCourseTypeChange(scope) {
            //修改课程类型时，恢复原来选择的课程的可选状态
            let tempCourseName = scope.row.fullName;
            let tempCourseComboData = [];
            if(this.oldCourseType != ''){
                tempCourseComboData = this.courseComboInfo[this.oldCourseType];
            }

            scope.row.fullName = null;
			scope.row.courseProperties = null;
            for (let i=0; i<tempCourseComboData.length; ++i) {
                if (tempCourseComboData[i].value === tempCourseName) {
                    tempCourseComboData[i].disabled = false;
                    break;
                }
            }

            let courseTypeCode = scope.row.courseKind;
            let courseTypeName = '';
            for(let i=0; i<this.kinds.length; i++){
                if(courseTypeCode === this.kinds[i].value){
                    courseTypeName = this.kinds[i].label;
                    break;
                }
            }
            scope.row.courseTypeName = courseTypeName;
        },
        handleCoursePropertiesOptionVisible(scope){

        },
        handleCourseFocus(scope) {
            //获得焦点时 改变下拉框的值
            // if(this.optionCourses == undefined){
            //     this.optionCourses = this.courseComboInfo[scope.row.courseKind];
            // }
            this.selectCourseId = (scope.row.courseId+'-'+scope.row.courseName);
            //获得焦点时 改变下拉框的值
            this.tempOptionCourses = [];
            this.filterOptionCourses = [];
            this.optionCourses = this.courseComboInfo[scope.row.courseKind];
            for(let i=0;i<this.optionCourses.length;i++){
                if((scope.row.courseId+'-'+scope.row.courseName) == this.optionCourses[i].value){
                    this.tempOptionCourses.push(this.optionCourses[i]);// 保存选中课程
                    this.filterOptionCourses.push(this.optionCourses[i]);// 保存选中课程
                    break;
                }
            }
            for(let i=0;i<this.optionCourses.length;i++){
                if((scope.row.courseId+'-'+scope.row.courseName) != this.optionCourses[i].value){
                    this.tempOptionCourses.push(this.optionCourses[i]);
                    if(i<10){
                        this.filterOptionCourses.push(this.optionCourses[i]);// 只显示前10条
                    }
                }
            }
        },
        handleCourseOptionVisible(scope){
            this.oldCourseName = scope.row.fullName;
        },
        // 自定义el-select的搜索实现方法
        searchFilterCourse(val) {
            let searchOptionCourse = [];
            for(let i=0;i<this.tempOptionCourses.length;i++){
                if(this.selectCourseId == this.tempOptionCourses[i].value){
                    searchOptionCourse.push(this.tempOptionCourses[i]);// 保存选中课程
                }
            }
            for(let i=0;i<this.tempOptionCourses.length;i++){
                if(this.tempOptionCourses[i].value.includes(val)){
                    searchOptionCourse.push(this.tempOptionCourses[i]);
                }
            }

            // 根据检索条件筛选出来的选项，只取前10条
            if (searchOptionCourse.length > 10) {
                this.filterOptionCourses = searchOptionCourse.slice(0, 10)
            } else {
                this.filterOptionCourses = searchOptionCourse;
            }
        },
        handleCourseChange(scope) {
            let newCourseName = scope.row.fullName;
            if (newCourseName == null) return;

            for (let i=0; i<this.optionCourses.length; ++i) {
                if (this.oldCourseName!="" && this.oldCourseName===this.optionCourses[i].value) {
                    this.optionCourses[i].disabled = false;
                }

                if (newCourseName === this.optionCourses[i].value) {
                    this.optionCourses[i].disabled = true;
                    scope.row.score = this.optionCourses[i].credit;
                    scope.row.totalTime = this.optionCourses[i].totalTime;
                    scope.row.theoryTime = this.optionCourses[i].theoryTime;
                    scope.row.practiseTime = this.optionCourses[i].practiseTime;

                    scope.row.courseCategory = this.optionCourses[i].courseCategory;
                    scope.row.courseCategoryName = this.optionCourses[i].courseCategoryName;

                    scope.row.kcsxholder = "请选择课程性质";
                    scope.row.kcsxDisabled = false;

                    this.kcsxInfo = [];
                    let kcsxs = this.optionCourses[i].courseProperties.split(",");
                    for(let j=0;j<this.kcsx.length;j++){
                        for(let k=0;k<kcsxs.length;k++){
                            if(kcsxs[k]==this.kcsx[j].comboValue){
                                this.kcsxInfo.push(this.kcsx[j]);
                            }
                        }
                    }

                    if(this.optionCourses[i].courseProperties==''){
                        scope.row.courseProperties = "";
                        scope.row.coursePropertiesName = "";
                    }else{
                        scope.row.courseProperties = this.optionCourses[i].courseProperties.split(",")[0];
                        for(let j=0;j<this.kcsx.length;j++){
                            if(this.optionCourses[i].courseProperties.split(",")[0]==this.kcsx[j].comboValue){
                                scope.row.coursePropertiesName = this.kcsx[j].comboName;
                            }
                        }
                    }
                    break;
                }
            }
            scope.row.courseId = newCourseName.split("-")[0];
            scope.row.courseName = newCourseName.split("-")[1];
        },
        handleExamTypeChange(scope){
            let examTypeCode = scope.row.examType;
            let examTypeName = '';
            for(let i=0; i<this.examType.length; i++){
                if(examTypeCode === this.examType[i].comboValue){
                    examTypeName = this.examType[i].comboName;
                     break;
                }
            }
            scope.row.examTypeName = examTypeName;
        },
        handleMajorcoreChange(scope){
            let majorcoreCode = scope.row.isMajorcore;
            let majorcoreName = '';
            for(let i=0; i<this.sfzt.length; i++){
                if(majorcoreCode === this.sfzt[i].comboValue){
                    majorcoreName = this.sfzt[i].comboName;
                     break;
                }
            }
            scope.row.isMajorcoreName = majorcoreName;
        },
        handleCertificateChange(scope){
            let certificateCode = scope.row.isCertificate;
            let certificateName = '';
            for(let i=0; i<this.sfzt.length; i++){
                if(certificateCode === this.sfzt[i].comboValue){
                    certificateName = this.sfzt[i].comboName;
                     break;
                }
            }
            scope.row.isCertificateName = certificateName;
        },
        formatterNumShow(str) {
            if (str == "0") str = "";

            return str;
        },
        formatterNumHour(term,week){
            let str = "";
            if (week == "0" || week == ""){
                if (term == "0" || term == ""){
                    str = "";
                } else {
                    str = term;
                }
            } else {
                if (term == "0" || term == ""){
                    str = "";
                } else {
                    str = term+" / "+week;
                }
            }
            return str;
        },
        handleRowClick(refName, row, column, event) {
            //获得焦点时 改变下拉框的值
            this.optionCourses = this.courseComboInfo[row.courseKind];

            //获取课程属性
            this.kcsxInfo = [];

            for (let i=0; i<this.optionCourses.length; ++i) {
                if (row.fullName === this.optionCourses[i].value) {
                    for(let j=0;j<this.kcsx.length;j++){
                        if(this.optionCourses[i].courseProperties.indexOf(this.kcsx[j].comboValue) > -1){
                            this.kcsxInfo.push(this.kcsx[j]);
                        }

                        // let kcsxs = this.optionCourses[i].courseProperties.split(",");
                        // for(let k=0;k<this.kcsxs.length;k++){
                        //     if(kcsxs[k]==this.kcsx[j].comboValue){
                        //         this.kcsxInfo.push(this.kcsx[j]);
                        //     }
                        // }
                    }

                    break;
                }
            }

            //不可编辑处理
            if(this.editDisableState){
                this.$refs.CAPTable.setCurrentRow();
            }
            this.$emit("changeEditRow", refName);
        },
        handleChange(){

        },
        getSummaries(param) {
            //统计求和函数
            const { columns, data } = param;
            const sums = [];

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }
                if (index===1 || index===2 || index===7 || index===8 || index===9) {
                    sums[index] = "";
                    return;
                }

                const values = data.map((item) =>
                    Number(item[column.property])
                );
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },
        //序号
        handleChangeXH(scope){
            let value = scope.row.xh;
            var pattern = /^[1-9]\d*$/;
            if(pattern.test(value)){
               if(parseInt(value,10)>200){
                   scope.row.xh = "";
               }else{
                   scope.row.xh = value;
               }
            }else{
               scope.row.xh = "";
            }
        },
    },
};
</script>

<style scoped>
    .numbers {
        width: 80%;
    }

    .tb-edit .el-edit {
        display: none;
    }

    .tb-edit .current-row .el-edit {
        display: block;
    }

    .tb-edit .current-row .el-edit + span {
        display: none;
    }

    .courseContent .el-table {
        overflow: visible;
    }

    .stickyContent {
        background-color: #ffffff;
        position: -webkit-sticky;
        position: sticky;
        z-index: 99999;
    }

    .el-edit /deep/ .el-input-group__append, .el-input-group__prepend {
        padding: 0 5px !important;
    }

    .el-edit /deep/ .el-input__inner {
        padding: 0 10px !important;
    }


</style>



// WEBPACK FOOTER //
// CourseAndProgress.vue?0a21837a